import { Component } from "@angular/core";
import { BaseComponent, AdminService, UserService, ProductService, environment } from "@mypxplat/xplat/core";
import { ClipboardService } from "ngx-clipboard";
import { NgxSpinnerService } from "ngx-spinner";
import { FileUploader, FileItem } from "ng2-file-upload";
import { KillKeysResult } from "libs/xplat/core/src/lib/models/admin.model";

@Component({
  selector: "myp-kill-keys",
  templateUrl: "kill-keys.component.html",
  standalone: false,
})
export class KillKeysComponent extends BaseComponent {
  public loading: boolean = false;
  public killing: boolean = false;
  public hasBaseDropZoneOver = false;
  public keysToKill: Array<string> = [];
  public killResult: KillKeysResult;
  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    url: environment.paeApiUrl + "/admin/product/kill-keys",
    method: "POST",
    queueLimit: 1,
  });

  public previewUploader: FileUploader;
  public fileName: string = "No file chosen";
  public uploadingFile: any;
  public uploadingComplete: boolean = false;
  public fileResponse: any;
  private fileSize = 100; // in megabytes

  constructor(
    userService: UserService,
    public productService: ProductService,
    public adminService: AdminService,
    private _spin: NgxSpinnerService,
    private _clipboardService: ClipboardService
  ) {
    super(userService);
    this.uploader.onAfterAddingFile = (file) => {
      let size = file.file.size;
      let ext = file.file.name.split(".").pop();
      this.fileName = file.file.name;
      if (ext !== "csv") {
        this.uploader.removeFromQueue(file);
        this.fileName = "No file chosen";
        this.keysToKill = [];
        alert("The file type you are trying to upload is not supported.");
      } else if (size > this.fileSize * 1024 * 1024) {
        this.uploader.removeFromQueue(file);
        this.fileName = "No file chosen";
        this.keysToKill = [];
        alert(`The file you selected exceeds the maximum file size for this type. The largest file you can upload is ${this.fileSize} MB`);
      } else {
        this.uploadingFile = file;
        file.withCredentials = false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = reader.result as string;
        const lines = text.split("\n");
        const keys = lines.map((line) => line.split(","));
        const flatKeys = keys.reduce((acc, val) => acc.concat(val), []);
        this.keysToKill = flatKeys.filter((key) => key.trim() !== "");
      };
      reader.readAsText(file._file);
    };
    this.uploader.onProgressAll = (progress: any) => {
      if (progress == 100) this.uploadingComplete = true;
    };
    this.uploader.response.subscribe((response) => {
      this.fileResponse = JSON.parse(response);
    });
  }

  fileOverBase(e, type) {
    this.hasBaseDropZoneOver = e;
  }

  killKeys(): void {
    if (this.keysToKill.length === 0) {
      alert("Please add keys to kill.");
      return;
    }

    this.killing = true;
    this.adminService.killKeys(this.keysToKill).subscribe({
      next: (result) => {
        this.killResult = result;
        this.killing = false;
        this.uploader.clearQueue();
        this.fileName = "No file chosen";
        this.keysToKill = [];
        alert("Some keys successfully killed!");
      },
      error: (error) => {
        this.killing = false;
        this.uploader.clearQueue();
        this.fileName = "No file chosen";
        this.keysToKill = [];
        alert("An error occurred while killing keys. Please try again.");
      },
    });
  }
}
